import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { BookOpen, Loader2, FileText } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function HelpTab() {
  const { http } = useAuth();
  const [docs, setDocs] = useState([]);
  const [current, setCurrent] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    http.get('/admin/help/docs').then((r) => {
      setDocs(r.data.docs);
      const first = r.data.docs.find((d) => d.available);
      if (first) open(first.name);
    }).catch(() => setErr('Could not load the documentation list.'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const open = async (name) => {
    setBusy(true); setErr('');
    try { const r = await http.get(`/admin/help/docs/${name}`); setCurrent(r.data); window.scrollTo({ top: 0 }); } catch (e) { setErr('Could not open that document.'); }
    setBusy(false);
  };

  return (
    <div className="grid gap-4 md:grid-cols-[260px_1fr]" data-testid="help-tab">
      <aside className="bg-white rounded-lg border p-3 h-fit md:sticky md:top-20" style={{ borderColor: 'rgba(0,0,0,0.08)' }}>
        <h3 className="font-title text-sm mb-2 flex items-center gap-2" style={{ color: 'var(--navy)' }}><BookOpen size={16} /> Documentation</h3>
        <ul className="space-y-1">
          {docs.map((d) => (
            <li key={d.name}>
              <button onClick={() => open(d.name)} disabled={!d.available} data-testid={`help-doc-${d.name.replace('.md', '').toLowerCase()}`}
                className="w-full text-left px-2 py-1.5 rounded text-sm" style={current?.name === d.name ? { background: 'var(--navy)', color: 'var(--cream)' } : { color: 'var(--ink)', opacity: d.available ? 1 : 0.5 }}>
                <div className="font-title flex items-center gap-1.5"><FileText size={12} /> {d.title}</div>
                <div className="text-[11px] opacity-80 leading-snug">{d.description}</div>
              </button>
            </li>
          ))}
        </ul>
        <p className="text-[11px] mt-3" style={{ color: 'var(--olive)' }}>Documents are kept in the project's <code>docs/</code> folder and shipped with every deploy.</p>
      </aside>
      <section className="bg-white rounded-lg border p-5 min-h-[400px] min-w-0 overflow-hidden" style={{ borderColor: 'rgba(0,0,0,0.08)' }} data-testid="help-doc-view">
        {err && <p className="text-sm px-3 py-2 rounded mb-3" style={{ background: '#fdecea', color: '#8a1f11' }} data-testid="help-error">{err}</p>}
        {busy && <p className="text-sm flex items-center gap-2" style={{ color: 'var(--olive)' }}><Loader2 size={14} className="animate-spin" /> Loading…</p>}
        {current && !busy && (
          <article className="help-markdown" data-testid="help-doc-content">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{current.markdown}</ReactMarkdown>
          </article>
        )}
      </section>
    </div>
  );
}
